<template>
  <div id="data-table">
    <table class="table table-striped table-hover table-sm">
      <thead>
      <tr>
        <th scope="col" v-for="item in header" :key="item.id">{{$t(item.name)}}</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="item in items" :key="item.id">
        <th scope="row" v-for="field in item" :key="field.id">{{field}}</th>
        <th scope="row" v-if="action">

        </th>
      </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
export default {
  name: 'DataTable',
  props: {
    fields: {
      type: Array,
      required: false
    },
    items: {
      type: Array,
      required: false
    },
    action: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function () {
    return {
      header: this.fields,
      body: this.items
    }
  },
  methods: {

  },
  created () {
    if (this.action) {
      this.header.push('action')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Partials/DataTable.vue